import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { registerUser } from '../api/auth';
import AuthShell from './auth/AuthShell';
import styles from './auth/AuthShell.module.css';
import { getAuthCopy } from './auth/authCopy';

const Register = () => {
  const { i18n } = useTranslation();
  const copy = getAuthCopy(i18n.language).register;
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [fullName, setFullName] = useState('');
  const [note, setNote] = useState('');
  const [message, setMessage] = useState('');
  const [messageTone, setMessageTone] = useState('success');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleRegister = async (event) => {
    event.preventDefault();
    setLoading(true);
    setMessage('');
    setMessageTone('success');

    try {
      const payload = {
        username,
        email,
        fullName,
        requestType: 'demo',
        note,
        role: 'normal',
      };
      const result = await registerUser(payload);
      setMessage(result.message || copy.successUser);
      setMessageTone('success');
      setUsername('');
      setEmail('');
      setFullName('');
      setNote('');
    } catch (error) {
      console.error('Error during registration:', error);
      setMessage(error.message || copy.error);
      setMessageTone('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      variant="register"
      eyebrow={copy.eyebrow}
      title={copy.title}
    >
      <form onSubmit={handleRegister} className={styles.formStack}>
        <div className={styles.formSection}>
          <div>
            <h2 className={styles.sectionHeading}>{copy.accessDetailsTitle}</h2>
          </div>

          <div className={styles.splitGrid}>
            <div className={styles.field}>
              <label className={styles.fieldLabel}>{copy.username}</label>
              <input
                type="text"
                value={username}
                onChange={(event) => setUsername(event.target.value)}
                required
                placeholder={copy.usernamePlaceholder}
                className={styles.input}
                autoComplete="username"
              />
            </div>

            <div className={styles.field}>
              <label className={styles.fieldLabel}>{copy.email}</label>
              <input
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
                placeholder="name@example.com"
                className={styles.input}
                autoComplete="email"
              />
            </div>
          </div>

          <div className={styles.field}>
            <label className={styles.fieldLabel}>{copy.fullName}</label>
            <input
              type="text"
              value={fullName}
              onChange={(event) => setFullName(event.target.value)}
              placeholder={copy.fullNamePlaceholder}
              className={styles.input}
              autoComplete="name"
            />
          </div>

          <div className={styles.field}>
            <label className={styles.fieldLabel}>{copy.reason}</label>
            <textarea
              value={note}
              onChange={(event) => setNote(event.target.value)}
              placeholder={copy.reasonPlaceholder}
              className={styles.textarea}
              rows={2}
            />
          </div>
        </div>

        {message ? (
          <p className={`${styles.message} ${messageTone === 'error' ? styles.messageError : styles.messageSuccess}`}>
            {message}
          </p>
        ) : null}

        <div className={styles.actionRow}>
          <button
            type="submit"
            className={styles.primaryButton}
            disabled={loading}
          >
            {loading ? copy.submitting : copy.submitRequest}
          </button>

          <p className={styles.helperText}>
            {copy.alreadyHaveAccessLead}{' '}
            <button type="button" onClick={() => navigate('/login')} className={styles.linkButton}>
              {copy.goToLogin}
            </button>
          </p>
        </div>
      </form>
    </AuthShell>
  );
};

export default Register;
